export default {
    namespaced: true,
    state: {
        // 為了我的最愛功能(favorites)，要存地圖的 zoom 、地圖中心、basemap、預報與觀測地圖產品、底圖產品
        zoom: 7,
        center: [23.8, 121.13],
        basemap: 'black',
        // meta_ids: [],
        // geomap_ids: []

    },

    mutations:{
        set_zoom(state, zoom) {
            state.zoom = zoom
        },

        set_center(state, center) {
            state.center = center
        },

        set_basemap(state, basemap) {
            state.basemap = basemap
        },

        // set_meta_ids(state, meta_ids) {
        //     state.meta_ids = meta_ids
        // },

        // set_geomap_ids(state, geomap_ids) {
        //     state.geomap_ids = geomap_ids
        // }
    },
    actions: {          
    
    },
    getters: {
     
    },
}